const main = () => {
    if (document.querySelector('#page-estate-index') == null) return;

    document.querySelectorAll('select[name="sort"]').forEach((obj) => {
        obj.addEventListener('change', (e) => {
            const sort = e.currentTarget.value;
            // ソートの値をクエリパラメータに追加して遷移
            const url = new URL(window.location.href);
            url.searchParams.set('sort', sort);
            url.searchParams.delete('page');
            window.location.href = url.toString();
        });
    });
}

export default main;
